import Logo from '@returnmates/ui-core/src/components/images/logo'
import { memo } from 'react'

import useStyles from './styles'

function LeftPartWithImages() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Logo className={classes.logoBackground} />
      <img src="/assets/images/plant.png" alt="Plant" className={classes.imagePlant} />
      <img src="/assets/images/shirt.png" alt="Shirt" className={classes.imageShirt} />
      <img src="/assets/images/statue.png" alt="Statue" className={classes.imageStatue} />
      <img src="/assets/images/chair.png" alt="Chair" className={classes.imageChair} />
      <img
        src="/assets/images/black-glasses.png"
        alt="Black glasses"
        className={classes.imageGlasses}
      />
      <img
        src="/assets/images/windbreaker.png"
        alt="Windbreaker"
        className={classes.imageWindbreaker}
      />
    </div>
  )
}

export default memo(LeftPartWithImages)
